export default __webpack_public_path__ + "static/media/image-ph-health-home-m@3x.9b779368.webp";